export default __webpack_public_path__ + "static/media/phubd_deactive.e46b83f3.svg";